// extracted by mini-css-extract-plugin
module.exports = {"noShadowLink":"shopinfo_noShadowLink__Zj9v2"};